import 'reflect-metadata';

// Monkey-patch Node prototype methods to prevent crashes from Google Translate / third-party DOM modifications
if (typeof Node !== 'undefined' && Node.prototype) {
    // 1. Patch removeChild to ignore NotFoundError (already removed or modified)
    const originalRemoveChild = Node.prototype.removeChild;
    Node.prototype.removeChild = function (child) {
        try {
            return originalRemoveChild.call(this, child);
        } catch (error) {
            if (error instanceof Error && (error.name === 'NotFoundError' || error.message.includes('NotFoundError'))) {
                return child;
            }
            throw error;
        }
    };

    // 2. Patch insertBefore to handle NotFoundError (fallback to appendChild) and child contains parent errors
    const originalInsertBefore = Node.prototype.insertBefore;
    Node.prototype.insertBefore = function (newNode, referenceNode) {
        try {
            return originalInsertBefore.call(this, newNode, referenceNode);
        } catch (error) {
            if (error instanceof Error) {
                if (error.name === 'NotFoundError' || error.message.includes('NotFoundError')) {
                    try {
                        return Node.prototype.appendChild.call(this, newNode);
                    } catch (innerError) {
                        if (innerError instanceof Error && innerError.message.includes('contains the parent')) {
                            console.warn('Bypassed insertBefore/appendChild fallback error (child contains parent):', innerError);
                            return newNode;
                        }
                        throw innerError;
                    }
                }
                if (error.message.includes('contains the parent')) {
                    console.warn('Bypassed insertBefore error (child contains parent):', error);
                    return newNode;
                }
            }
            throw error;
        }
    };

    // 3. Patch appendChild to handle child contains parent errors gracefully
    const originalAppendChild = Node.prototype.appendChild;
    Node.prototype.appendChild = function (child) {
        try {
            return originalAppendChild.call(this, child);
        } catch (error) {
            if (error instanceof Error && error.message.includes('contains the parent')) {
                console.warn('Bypassed appendChild error (child contains parent):', error);
                return child;
            }
            throw error;
        }
    };
}

/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/** IE10 and IE11 requires the following for NgClass support on SVG elements */
// import 'classlist.js';  // Run `npm install --save classlist.js`.

/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 */
import 'web-animations-js';  // Run `npm install --save web-animations-js`.

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.


/***************************************************************************************************
 * APPLICATION IMPORTS
 */
(window as any)['global'] = window;
import {Settings} from 'luxon';
Settings.defaultLocale = 'pt-BR';
Settings.defaultZone = 'America/Sao_Paulo';
